import React from 'react';
import { useActiveListContext } from '../../context';
import { Core } from '..';

export default function ScreenAlerts() {
  const { themeColor } = useActiveListContext();

  return (
    <>
      <div className='rotateAlert'>
        <Core.ForceAlert color={themeColor} showBox={true}>
          Please rotate the screen
        </Core.ForceAlert>
      </div>
      <div className='resizeAlert'>
        <Core.ForceAlert color={themeColor} showBox={true}>
          Please resize the screen
        </Core.ForceAlert>
      </div>
    </>
  );
}
